import React from 'react';
import { Link } from '@scentregroup/shared/link';
import classNames from 'classnames';
import Heading from "@scentregroup/ui/components/heading";
import Paragraph from "@scentregroup/ui/components/paragraph";
import MoviePoster from '../../movie-poster';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Card = _ref => {
  let {
    className,
    link,
    image,
    title,
    classification = ''
  } = _ref;
  return /*#__PURE__*/_jsxs(Link, {
    className: classNames(style.Card, className),
    to: link,
    "data-id": "card_index_Card_Link",
    children: [/*#__PURE__*/_jsx(MoviePoster, {
      className: style.cardImage,
      image: image,
      "data-id": "card_index_Card_Link_MoviePoster"
    }), /*#__PURE__*/_jsx(Heading, {
      type: "extrasmall",
      className: style.cardTitle,
      "data-test-id": "movie-title",
      "data-id": "card_index_Card_Link_Heading",
      children: title
    }), /*#__PURE__*/_jsx(Paragraph, {
      className: style.cardClassification,
      "data-id": "card_index_Card_Link_Paragraph",
      children: classification
    })]
  });
};
export default Card;